/**
 * The rider's optional "note for Anna" on a local ride. Pure, unit-tested.
 *
 * Quick notes are sent as codes so the Anna app shows them in Telugu; the same
 * codes are in firebase/functions/riderNote.js (the server drops unknown ones)
 * and the Anna app's RiderNote.kt. The free text is shown to him as typed.
 * The note is stored away from the ride doc and only the Anna who accepts can
 * read it (see the server file).
 */

export const RIDER_NOTE_CHIPS = ['gate', 'call', 'lane', 'luggage', 'elder', 'kids'];
export const RIDER_NOTE_MAX_TEXT = 120;
// Same pattern as the server: a 10-digit Indian mobile, with or without +91.
const PHONE_RE = /(?:\+?91[\s-]?)?[6-9](?:[\s-]?\d){9}/;

export const noteHasPhone = (text) => PHONE_RE.test(String(text || ''));

export const cleanNoteText = (raw) => String(raw ?? '')
  .replace(/[\u0000-\u001f\u007f]/g, ' ') // eslint-disable-line no-control-regex
  .replace(/\s+/g, ' ')
  .trim()
  .slice(0, RIDER_NOTE_MAX_TEXT);

/** `{ chips, text }` to send, or null when there is nothing (or only junk). */
export const buildRiderNote = (chips, text) => {
  const cleanChips = [...new Set((chips || []).map(String))].filter((c) => RIDER_NOTE_CHIPS.includes(c));
  const cleanText = cleanNoteText(text);
  if (!cleanChips.length && !cleanText) return null;
  return { chips: cleanChips, text: cleanText };
};

/** One line for the rider's own screens: quick notes in their language, then their text. */
export const riderNoteSummary = (note, t) => {
  if (!note) return '';
  const chips = (note.chips || []).filter((c) => RIDER_NOTE_CHIPS.includes(c)).map((c) => t(`riderNote.chip_${c}`));
  return [...chips, cleanNoteText(note.text)].filter(Boolean).join(' · ');
};

/** The current Anna has opened the note (his app stamps `seenBy` with his uid). */
export const riderNoteSeen = (note, ride) => Boolean(note?.seenBy && ride?.driverId && note.seenBy === ride.driverId);
